import { ContentTitle } from './ContentTitle';
import * as React from 'react';
import styled from 'styled-components';
import { useTheme } from '@material-ui/core';
import { useIsMobile } from 'app/hooks/useIsMobile';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import { translations } from 'locales/translations';
import { bookitColors } from 'styles/colors/bookitColors';

export interface LoginWrapperProps {
  children: React.ReactNode;
  help_Login?: string | null;
  pageTitle?: React.ReactNode;
  pageDescription?: React.ReactNode;
  showTopProcessing?: boolean;
  disabled: boolean;
  contentMaxWidth: number;
}

export const Wrapper = styled('div')(({ theme }) => ({
  '&.loginWrapperRoot': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '24px',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      padding: '0px 24px 16px 24px',
      height: '100%',
      overflowY: 'auto',
      //justifyContent: 'flex-start',
    },
    '& .loginFooter': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      border: `1px solid ${bookitColors.primary.componentsLight}`,
      borderRadius: '8px',
      padding: '12px',
      gap: 10,
    },
    '& .loginContentBody': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '16px',
      alignSelf: 'center',
      maxWidth: '320px',
      // height: '100%',
      // overflowY: 'auto',
      width: '100%',
    },
  },
}));
export function LoginWrapper(props: LoginWrapperProps) {
  const {
    children,
    help_Login,
    pageTitle,
    pageDescription,
    showTopProcessing,
    disabled,
    contentMaxWidth,
  } = props;

  const theme = useTheme();
  const { checkIsMobile } = useIsMobile();
  const isMobile = checkIsMobile();
  const { t } = useTranslation();
  const loginFooter = React.useMemo(() => {
    return t(translations.LoginFooter);
  }, [t]);
  return (
    <Wrapper
      className={'loginWrapperRoot'}
      theme={theme}
      style={{
        maxWidth: contentMaxWidth,
        pointerEvents: disabled ? 'none' : 'auto',
      }}
    >
      <ContentTitle
        help_Login={help_Login}
        title={pageTitle}
        description={pageDescription}
        isMobile={isMobile}
        showTopProcessing={showTopProcessing}
      />
      <div className={'loginContentBody'}>{children}</div>
      {!!loginFooter && loginFooter !== '' && (
        <div className={'loginFooter'}>{parse(loginFooter)}</div>
      )}
    </Wrapper>
  );
}
